import PBService from "@irati/utils/services"
import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {
  QueryGetTopUpArgs,
  MutationCompleteTopUpArgs,
  QueryGetTopUpsArgs,
  MutationCreateTopUpArgs,
  CreateTenantWalletTransfersInput
} from "@irati/types/ops"
import {Topup, WalletTopupServiceCharge} from "@irati/types"
import getTopUpQuery, {getTopUpKey} from "./queries/getTopUp"
import completeTopupMutation, {completeTopupKey} from "./mutations/completeTopup"
import getTopUpsQuery, {getTopUpsKey} from "./queries/getTopUps"
import createTopUpMutation, {createTopUpKey} from "./mutations/createTopup"
import createTenantWalletTransfers from "./mutations/TenantWalletTransfers"
import serviceChargeQuery, {serviceChargeKey} from "./queries/serviceCharge"

class TopUpWallet extends PBService {
  list(args: QueryGetTopUpsArgs, options: QueryOptions = {}) {
    const variables = {
      ...args
    }
    return client.query({...options, query: getTopUpsQuery, variables}).then(({data}) => data[getTopUpsKey])
  }

  get(topupId: string, options: QueryOptions = {}): Promise<Topup> {
    const variables: QueryGetTopUpArgs = {topupId}
    return client.query({...options, query: getTopUpQuery, variables}).then(({data}) => data[getTopUpKey])
  }

  create(args: MutationCreateTopUpArgs, options: MutationOptions = {}) {
    const variables = {
      ...args
    }
    return client.mutate({...options, mutation: createTopUpMutation, variables}).then(({data}) => data[createTopUpKey])
  }

  complete(topupId: string, options: MutationOptions = {}) {
    const variables: MutationCompleteTopUpArgs = {topupId}
    return client.mutate({...options, mutation: completeTopupMutation, variables}).then(({data}) => data[completeTopupKey])
  }

  createLegacyTenantWalletTransfer(data: CreateTenantWalletTransfersInput): Promise<boolean> {
    return client.mutate({mutation: createTenantWalletTransfers, variables: {data}}).then(() => true)
  }

  serviceCharge(options: QueryOptions = {}): Promise<WalletTopupServiceCharge> {
    return client.query({...options, query: serviceChargeQuery}).then(({data}) => data[serviceChargeKey])
  }
}

const topupService = new TopUpWallet({errorHandlers: []})

export default topupService
